import { Info } from 'lucide-react'

import { Alert, AlertDescription } from '@/components/ui/alert'

interface SupersessionWarningAlertProps {
  invoiceNumber: string
}

/**
 * Mode A informational alert telling Élodie what will happen when she
 * confirms the cancellation. NOT destructive variant — the action is a
 * regular legal operation, not a destructive one. SOLY-CN-001 mini-scope 04.
 */
export function SupersessionWarningAlert({ invoiceNumber }: SupersessionWarningAlertProps) {
  return (
    <Alert data-testid="credit-note-supersession-warning">
      <Info className="h-4 w-4" />
      <AlertDescription>
        La facture <span className="font-mono font-medium">{invoiceNumber}</span> sera marquée{' '}
        <span className="font-medium">REMPLACÉE</span>. Vous pourrez réémettre une nouvelle facture du
        même type si nécessaire (utile en cas d'erreur).
      </AlertDescription>
    </Alert>
  )
}
